import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9anqzdvs32: FaireBrandEntity = {
  token: "b_9anqzdvs32",
  type: "brand",
  name: "The French Farm",
  avatarUrl:
    "https://cdn.faire.com/fastly/5a1bd662ac511fe2f03b1d0ee632e8acac4b8d3ee96e152f6e2949009b4d3f6f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/11720875b44c701109e30938c8dc85d488634f5847c50edc8966dcb75844c60d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5a1bd662ac511fe2f03b1d0ee632e8acac4b8d3ee96e152f6e2949009b4d3f6f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/11720875b44c701109e30938c8dc85d488634f5847c50edc8966dcb75844c60d.jpeg",
  location: "Houston, TX, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 139,
  isTopShop: true,
  isInsider: true,
  description:
    "The French Farm was established in 1997 by Gisele Oriot, a visionary originally hailing from a renowned French region celebrated for its food culture and wine. Upon settling in Houston, she sensed a void that needed to be filled. Gisele yearned for the exceptional gourmet food products and kitchen accessories that had surrounded her back home. Realizing that she alone held the power to bring the jams, mustards, oils, and cutlery she missed to Houston, she embarked on a mission.\n\nWhat began as a personal endeavor, sourcing gourmet products for her own enjoyment and that of her friends, quickly transformed into a thriving business, giving birth to The French Farm.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:09.955Z",
    importedBy: "entity-db-cli",
  },
};
